<template>
    <kgr-icon
        icon-class="pause"
        :title="title"
        :small="small"
        circle
        :class="{ 'kgr-icon--active': !disabled }"
    />
</template>

<script>
import Icon from './Icon.vue';

export default {
    components: {
        'kgr-icon': Icon,
    },
    props: {
        title: {
            type: String,
            required: false,
            default: '',
        },
        small: {
            type: Boolean,
            required: false,
        },
        disabled: {
            type: Boolean,
            required: false,
            default: false,
        },
    },
};
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
    .kgr-icon {
    background-color: orange;
    color: white !important;
}
</style>
